import React from "react";

import SidebarNavSection from "./SidebarNavSection.js";

const SidebarNav = ({ items }) => {

  return (
    <ul className="sidebar-nav">
      {items &&
        items.map((item) => (
          <SidebarNavSection
            key={item.title}
            pages={item.pages}
            title={item.title}
            icon={item.icon}
            collapsible={item.collapsible}
            defaultOpen={item.defaultOpen}
          />
        ))}
    </ul>
  );
};

export default SidebarNav;
